import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  class: "jl2-custom-filled-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.999998 15C0.999998 7.26801 7.26801 0.999998 15 0.999998C22.732 0.999998 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 0.999998 22.732 0.999998 15Z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21 18L15 12L9 18",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1)
  ])))
}